<template>
  <div>
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="!pageLoading">
      <v-container fluid>
        <v-row>
          <v-col class="d-flex">
            <h4 class="mb-2 mr-8">{{ $t('cleaners.available') }}</h4>
            <v-btn
              tile
              :loading="isRequestingNow"
              :disabled="!isValidAvailability"
              @click="onUpdateAvailability"
            >{{ $t('actions.save') }}
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-for="region in Object.keys(availibility)" :key="region" cols="12" md="6">
            <v-card flat outlined class="pa-2 mb-1">
              <h4 class="mb-1 text-center">
                <b>
                  {{ $t('global.filter.regions.' + region) }}
                </b>.
                {{ $t('cleaners.base_orders') }}
              </h4>
              <div>
                <h5 class="mb-1">{{ $t('cleaners.morning') }} ({{ $t('cleaners.before') }} {{ cleanerPMTimeStart }} {{ $t('cleaners.hours') }}.)</h5>
                <div class="d-flex justify-start flex-wrap">
                  <div
                    class="mr-2 availability-wrap"
                    v-for="day in Object.keys(availibility[region].base.am)"
                    :key="`${region}-base-am-${day}`"
                  >
                    <v-text-field
                      :label="moment(day).locale(getCurrentLocale()).format('DD-MMM')"
                      v-model="availibility[region].base.am[day]"
                      type="number"
                      autocomplete="off"
                      :rules="rules"
                      persistent-hint
                      outlined
                      persistent-placeholder
                      dense
                      @input="checkAvailability(region, 'base', 'am')"
                    />
                  </div>
                </div>
              </div>

              <div>
                <h5 class="mb-1">{{ $t('cleaners.day') }}</h5>
                <div class="d-flex justify-start flex-wrap">
                  <div
                    class="mr-2 availability-wrap"
                    v-for="day in Object.keys(availibility[region].base.pm)"
                    :key="`${region}-base-pm-${day}`"
                  >
                    <v-text-field
                      :label="moment(day).locale(getCurrentLocale()).format('DD-MMM')"
                      v-model="availibility[region].base.pm[day]"
                      type="number"
                      autocomplete="off"
                      :rules="rules"
                      persistent-hint
                      outlined
                      persistent-placeholder
                      dense
                      @input="checkAvailability(region, 'base', 'pm')"
                    />
                  </div>
                </div>
              </div>
            </v-card>

            <v-card flat outlined class="pa-2 mb-4">
              <h4 class="mb-1 text-center">
                <b>{{ $t('global.filter.regions.' + region) }}</b>.
                {{ $t('cleaners.complex_orders') }}
              </h4>
              <div>
                <h5 class="mb-1">{{ $t('cleaners.morning') }} ({{ $t('cleaners.before') }} {{ cleanerPMTimeStart }} {{ $t('cleaners.hours') }}.)</h5>
                <div class="d-flex justify-start flex-wrap">
                  <div
                    class="mr-2 availability-wrap"
                    v-for="day in Object.keys(availibility[region].complex.am)"
                    :key="`${region}-complex-am-${day}`"
                  >
                    <v-text-field
                      :label="moment(day).locale(getCurrentLocale()).format('DD-MMM')"
                      v-model="availibility[region].complex.am[day]"
                      type="number"
                      autocomplete="off"
                      :rules="rules"
                      persistent-hint
                      outlined
                      persistent-placeholder
                      dense
                      @input="checkAvailability(region, 'complex', 'am')"
                    />
                  </div>
                </div>
              </div>

              <div>
                <h5 class="mb-1">{{ $t('cleaners.day') }}</h5>
                <div class="d-flex justify-start flex-wrap">
                  <div
                    class="mr-2 availability-wrap"
                    v-for="day in Object.keys(availibility[region].complex.pm)"
                    :key="`${region}-base-pm-${day}`"
                  >
                    <v-text-field
                      :label="moment(day).locale(getCurrentLocale()).format('DD-MMM')"
                      v-model="availibility[region].complex.pm[day]"
                      type="number"
                      autocomplete="off"
                      :rules="rules"
                      persistent-hint
                      outlined
                      persistent-placeholder
                      dense
                      @input="checkAvailability(region, 'complex', 'pm')"
                    />
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <filter-cleaners
        :default-search-params="searchParams"
        :is-component-loading="isRequestingNow"
        @filtering="onFilter"
        @download-excel="onDownloadExcel"
      ></filter-cleaners>

      <table-paginated-cleaners
        :is-component-loading="isRequestingNow"
        :paginated-object="paginatedObject"
        @edit-item="onPaginatedItemEdit"
        @delete-item="onPaginatedItemDelete"
      ></table-paginated-cleaners>

      <pagination-listing
        :pagination-data="paginationData"
        @go-prev="changePage('-')"
        @go-next="changePage('+')"
      ></pagination-listing>
    </div>
    <modal-loading :is-show="isTableLoading"></modal-loading>
    <!-- Edit Modal -->
    <edit-modal-cleaner
      :item="currentEditableItem"
      :is-show-dialog="isShowUserDialog"
      :is-modal-loading="isLoadingUserDialog"
      :action-label="userDialogActionLabel"
      :errors="errorsUserDialog"
      @on-close="onCloseUserDialog"
      @on-action="onActionUserDialog"
    />
    <v-btn
      color="pink"
      dark
      fixed
      bottom
      right
      fab
      @click="currentEditableItem = {}; isShowUserDialog = true"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <!-- End: Edit Modal -->
    <accept-dialog
      :is-open-dialog="isShowDeleteDialog"
      @on-close="isShowDeleteDialog=false"
      @on-accept="onAcceptDeletion"
    >
      <div class="pt-6">{{ acceptModalText }}</div>
    </accept-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* constants */
import { PER_PAGE } from '@/constants/listing';
import { DONE } from '../../constants/order_statuses';
/* utils */
import { prepareValidationMessages, strReplaceAll } from '@/utils/index';
/* proxies */
import CleanerProxy from '@/proxies/Cleaner/CleanerProxy';
/* mixins */
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import paginationMixin from '@/mixins/listing/paginationMixin';
import downloadReport from '@/mixins/reports/downloadReport';
import { REGIONS } from '~constants/region';
/* components */
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import FilterCleaners from '@/components/listings/FilterCleaners.vue';
import TablePaginatedCleaners from '@/components/listings/TablePaginatedCleaners.vue';
import EditModalCleaner from '@/components/listings/EditModalCleaner.vue';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';
import CleanerTransformer from '@/transformers/Cleaners/CleanerTransformer';

export default {
  name: 'CleanersIndex',
  components: {
    ModalLoading,
    AcceptDialog,
    FilterCleaners,
    TablePaginatedCleaners,
    PaginationListing,
    EditModalCleaner,
  },
  mixins: [
    updatePageContentMixin,
    paginationMixin,
    defaultListingMixin,
    downloadReport,
  ],
  data() {
    return {
      cleanerPMTimeStart: process.env.VUE_APP_CLEANER_PM_HOUR_START,
      moment,
      reportMethodName: 'cleanersListingReport',
      /* Page management */
      pageLoading: false,
      /* Create - Edit user */
      isLoadingUserDialog: false,
      isRequestingNow: false,
      errorsUserDialog: {},
      isShowUserDialog: false,
      currentEditableItem: {},
      /* Delete user */
      isShowDeleteDialog: false,
      /* Listing management */
      isTableLoading: false,
      fetchDataOnCreated: true,
      searchParams: {
        search: '',
        active: 1,
        role: null,
        region: null,
        with_orders_count_ordered_done: true,
        with_negatives: true,
        page: {
          number: 1,
          size: PER_PAGE,
        },
      },
      availibility: {},
      isValidAvailability: true,
      rules: [v => (!Number.isNaN(v) && v >= 0) || 'Ошибка'],
    };
  },
  computed: {
    /* edit modal */
    userDialogActionLabel() {
      if (this.isShowUserDialog) {
        return this.currentEditableItem.name ?
          this.lang(this.$store, 'sap/listings.global.edit.save') :
          this.lang(this.$store, 'sap/listings.global.edit.create');
      }
      return '';
    },
    /* accept modal */
    acceptModalText() {
      return strReplaceAll(
        this.lang(this.$store, 'sap/listings.global.delete.question'),
        {
          user: this.currentEditableItem.name,
        },
      );
    },
    /* store */
    account() {
      return this.$store.getters['account/account'];
    },
  },
  created() {
    this.fetchAvailibility();
  },
  methods: {
    getCurrentLocale() {
      return window.localStorage.language;
    },
    checkAvailability(region, type, dayPart) {
      if (
        Object.values(this.availibility[region][type][dayPart])
          .some(
            value => Number.isNaN(value) || Number(value) < 0,
          )
      ) {
        this.isValidAvailability = false;
        return;
      }
      this.isValidAvailability = true;
    },
    fetchData() {
      this.isRequestingNow = true;
      new CleanerProxy()
        .setParameters(this.searchParams)
        .all()
        .then(response => {
          // eslint-disable-next-line no-param-reassign
          response.data.data.cleaners.data = CleanerTransformer.fetchCollection(
            response.data.data.cleaners.data,
          );
          this.paginatedObject = response.data.data.cleaners;
        })
        .catch(error => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    fetchAvailibility() {
      this.isRequestingNow = true;
      const params = {
        regions: Object.keys(REGIONS),
      };
      new CleanerProxy()
        .availibility(params)
        .then(({ data }) => {
          this.availibility = data;
          /*           Object.entries(data.base).forEach(([dayKey, value]) => {
            this.availibility[dayKey] = value;
          Object.entries(data.complex).forEach(([dayKey, value]) => {
            this.availibilityComplex[dayKey] = value;
          }); */
        })
        .catch(error => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    onPaginatedItemEdit(item) {
      this.currentEditableItem = item;
      this.isShowUserDialog = true;
    },
    onPaginatedItemDelete(item) {
      this.currentEditableItem = item;
      this.isShowDeleteDialog = true;
    },
    /**
     * @see defaultListingMixin
     * @param newSearchParams
     * @returns {*}
     */
    filterSearchParamsBeforeSend(newSearchParams) {
      if (_.isString(newSearchParams.role)) {
        // eslint-disable-next-line no-param-reassign
        newSearchParams.role = [newSearchParams.role];
      }
      if (_.isString(newSearchParams.region)) {
        // eslint-disable-next-line no-param-reassign
        newSearchParams.region = [newSearchParams.region];
      }
      return newSearchParams;
    },
    onCloseUserDialog() {
      this.isShowUserDialog = false;
    },
    onActionUserDialog(item) {
      if (_.isObject(item)) {
        this.isLoadingUserDialog = true;
        let client = new CleanerProxy();
        const cleaner = CleanerTransformer.send(item);
        if (this.currentEditableItem.uuid) {
          client = client.update(this.currentEditableItem.uuid, cleaner);
        } else {
          client = client.create(cleaner);
        }

        client
          .then(response => {
            this.currentEditableItem = response.data.data.cleaner;
            this.$store.dispatch('page/updateCurrentPageContent');
            this.isShowUserDialog = false;
          })
          .catch(response => {
            this.errorsUserDialog = prepareValidationMessages(
              response.data.data,
            );
          })
          .finally(() => {
            this.isLoadingUserDialog = false;
          });
      }
    },
    onAcceptDeletion() {
      this.isRequestingNow = true;
      new CleanerProxy()
        .destroy(this.currentEditableItem.uuid)
        .catch(response => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.fetchData();
        });
    },
    onUpdateAvailability() {
      this.isRequestingNow = true;
      const value = {};
      Object.keys(this.availibility)
        .forEach(region => {
          value[region] = this.availibility[region];
        });
      const data = {
        regions: Object.keys(REGIONS),
        value: value,
      };
      new CleanerProxy()
        .updateAvailibility(data)
        .then(response => {
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Данные обновлены',
            color: 'green darken-3',
            timeout: 6000,
          });
        })
        .catch(response => {
        })
        .finally(() => {
          this.isRequestingNow = false;
        });
    },
  },
};
</script>
<style lang="sass">
.availability-wrap
  max-width: 70px
</style>
